/**
 * @prettier
 */
import { BigNumber } from 'bignumber.js';

export function sum(prev: any, next: any): BigNumber {
    return BigNumber(prev).plus(next);
}
